"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatFilledIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 *
 */
function ChatFilledIcon({ size }) {
    return ((0, jsx_runtime_1.jsx)("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "#2C3137", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M20 18.3557V20.2322C20 20.6562 19.6418 21 19.2 21C19.0359 21 18.8757 20.9515 18.7412 20.8612L15.0121 18.3557H8C5.79086 18.3557 4 16.637 4 14.5168V6.83893C4 4.71875 5.79086 3 8 3H16C18.2091 3 20 4.71875 20 6.83893V18.3557Z" }) }));
}
exports.ChatFilledIcon = ChatFilledIcon;
//# sourceMappingURL=ChatFilledIcon.js.map